/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import $ from 'jquery';

const closeMenu = () => {
  $('.header li').removeClass('active');
  $('.body').removeClass('open');
  $('.body').attr('style', '');
  $('.navigation').css('left', '-24rem');
  $('.overlay').attr('style', '');
}

const openMenu =  (link) => {
  $('.header li').removeClass('active');
  $(link).parent().addClass('active');
  $('.body').addClass('open');
  $('.overlay').css('opacity', '0.4');
  $('.body').css('max-height', getHeight());
  $('.navigation').css('left', '0');
}

const getHeight = () => {
  return $(window).height() - $('.header').height();
}

const setupListeners = () => {
    const height = getHeight();
      $('.navigation').css('height', getHeight());

      $('.header li a').each(function() {
        $(this).on('click', function(e) {
          openMenu(e.target);
          e.preventDefault();
        });

        $('.overlay').on('click', function(e) {
          closeMenu();
        })
      });    
}

exports.onRouteUpdate = ({ location }) => {
  // setupListeners();
}

exports.onInitialClientRender = () => {
  // setupListeners();
}


// WEBPACK FOOTER //
// ./gatsby-browser.js